import React, { useState } from 'react';
import Header from './Header';
import HeroSection from './HeroSection';
import MarketVideoSection from './MarketVideoSection';
import OverviewSection from './OverviewSection';
import ExpansionSection from './ExpansionSection';
import StructuresSection from './StructuresSection';
import ResilienceSection from './ResilienceSection';
import ExceptionalValueSection from './ExceptionalValueSection';
import PresentationSection from './PresentationSection';
import VirtualTourSection from './VirtualTourSection';
import RelocationSection from './RelocationSection';
import LocationSection from './LocationSection';
import GallerySection from './GallerySection';
import ContactSection from './ContactSection';
import Footer from './Footer';
import ShareModal from './ShareModal';
import ScheduleModal from './ScheduleModal';
import { Toaster } from 'sonner';

/*
  INFORMATION ARCHITECTURE (Phase 2 - Updated):
  A. HERO — SCARCITY + VISION
  B. NEW MARKET VIDEO
  C. THE COMPLETE ESTATE / VALUE STACK (Overview)
  D. 20-ACRE AERIAL / PROPERTY SCALE (Expansion)
  D2. INTERACTIVE WILLIAM LANE PRESENTATION (moved up)
  E. TURNKEY BUSINESS / COLLECTOR / EQUESTRIAN INFRASTRUCTURE (Structures)
  F. RESILIENCE & PREPAREDNESS
  G. EXCEPTIONAL VALUE IN TODAY'S MARKET
  I. VIRTUAL PROPERTY TOUR
  J. RELOCATION & CENTRAL FLORIDA OPPORTUNITY
  K. LOCATION INTELLIGENCE
  L. PHOTO GALLERY
  M. WHO THIS ESTATE IS FOR (ContactSection)
  N. DIRECT PRIVATE INQUIRY (ContactSection)
  O. FOOTER
*/

const PropertyMicrosite = () => {
  const [shareModalOpen, setShareModalOpen] = useState(false);
  const [scheduleModalOpen, setScheduleModalOpen] = useState(false);
  const [isHeroVideoPlaying, setIsHeroVideoPlaying] = useState(false);

  const handleInquire = () => {
    // Scroll to contact section or open modal
    const contactSection = document.getElementById('inquire');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleScheduleViewing = () => {
    setScheduleModalOpen(true);
  };

  const handleShare = () => {
    setShareModalOpen(true);
  };

  const handleHeroVideoPlay = (playing) => {
    setIsHeroVideoPlaying(playing);
  };

  return (
    <div className="min-h-screen bg-[#0d1117]" data-testid="property-microsite">
      <Toaster 
        position="top-right" 
        richColors 
        toastOptions={{
          className: 'bg-[#1a1f2e] border-white/10 text-white',
        }}
      />
      
      {/* Header with W Crest - NO REALTOR REFERENCES */}
      <Header 
        onInquire={handleInquire} 
        onShare={handleShare} 
        isVideoPlaying={isHeroVideoPlaying} 
      />
      
      <main>
        {/* A. HERO — SCARCITY + VISION */}
        <HeroSection 
          onInquire={handleInquire} 
          onVideoPlay={handleHeroVideoPlay} 
        />
        
        {/* B. NEW MARKET VIDEO - "SEE WHY THIS ESTATE IS DIFFERENT" */}
        <MarketVideoSection heroVideoPlaying={isHeroVideoPlaying} />
        
        {/* C. THE COMPLETE ESTATE / VALUE STACK */}
        <OverviewSection />
        
        {/* D. 20-ACRE AERIAL / EXPANSION POTENTIAL */}
        <ExpansionSection onInquire={handleInquire} />
        
        {/* D2. INTERACTIVE WILLIAM LANE PRESENTATION (moved up - below Expansion, before Infrastructure) */}
        <PresentationSection onInquire={handleInquire} />
        
        {/* E. TURNKEY BUSINESS / COLLECTOR / EQUESTRIAN INFRASTRUCTURE */}
        <StructuresSection />
        
        {/* F. RESILIENCE & PREPAREDNESS */}
        <ResilienceSection />
        
        {/* G. EXCEPTIONAL VALUE IN TODAY'S MARKET */}
        <ExceptionalValueSection />
        
        {/* I. VIRTUAL PROPERTY TOUR (RETAINED) */}
        <VirtualTourSection />
        
        {/* J. RELOCATION & CENTRAL FLORIDA OPPORTUNITY */}
        <RelocationSection />
        
        {/* K. LOCATION INTELLIGENCE */}
        <LocationSection />
        
        {/* L. PHOTO GALLERY (images 62-74 removed) */}
        <GallerySection />
        
        {/* M & N. WHO THIS ESTATE IS FOR + DIRECT PRIVATE INQUIRY */}
        <ContactSection />
      </main>
      
      {/* O. FOOTER - NO REALTOR REFERENCES */}
      <Footer />

      {/* Mobile Floating CTA - NO REALTOR PHONE */}
      <div className="fixed bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black via-black/95 to-transparent md:hidden z-40">
        <div className="flex space-x-3">
          <button
            onClick={handleScheduleViewing}
            className="flex-1 py-4 bg-white/10 backdrop-blur-md border border-white/20 rounded-xl text-white font-medium text-center"
            data-testid="mobile-schedule-btn"
          >
            Request Viewing
          </button>
          <button
            onClick={handleInquire}
            className="flex-1 py-4 bg-gradient-to-r from-amber-500 to-amber-600 rounded-xl text-white font-medium shadow-lg shadow-amber-500/30"
            data-testid="mobile-inquire-btn"
          >
            Inquire Privately
          </button>
        </div>
      </div>

      {/* Modals */}
      <ShareModal isOpen={shareModalOpen} onClose={() => setShareModalOpen(false)} />
      <ScheduleModal isOpen={scheduleModalOpen} onClose={() => setScheduleModalOpen(false)} />
    </div>
  );
};

export default PropertyMicrosite;
